import {
  Button,
  Grid,
  Menu,
  MenuItem,
  ListItemIcon,
} from "../../../../components";
import { useState } from "react";

const ButtonMenu = ({
  status,
  onClickEmitir,
  onClickVisualizar,
  onClickCancelar,
  onClickBaixarXml,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const buttonStyle = {
    borderRadius: 5,
    backgroundColor: "#E5E5E5",
    margin: "1em",
  };

  function handleAddActionsClose() {
    setAnchorEl(null);
  }

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const renderMainButtons = () => {
    if (status === "PENDENTE") {
      return (
        <Button
          id="danfeButton"
          className="my-3"
          variant="outlined"
          color="primary"
          size="small"
          onClick={() => {
            onClickEmitir();
          }}
        >
          Emitir NFS-e
        </Button>
      );
    }
    if (status === "ENVIADA") {
      return (
        <>
          <Button
            id="danfeButton"
            className="my-3 me-2"
            variant="outlined"
            color="primary"
            size="small"
            onClick={() => {
              onClickVisualizar();
            }}
          >
            Visualizar NFS-e
          </Button>
          <Button
            aria-label="add action caixa"
            aria-controls={"primary-add-actions-menu"}
            aria-haspopup="true"
            aria-expanded={isMenuOpen ? "true" : "false"}
            onClick={handleMenuOpen}
            color="inherit"
            style={buttonStyle}
          >
            <span style={{ fontSize: 10 }}>mais ações</span>
          </Button>
          <Menu
            anchorEl={anchorEl}
            elevation={1}
            getContentAnchorEl={null}
            id={"primary-add-actions-menu"}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            autoFocus={false}
            open={isMenuOpen}
            onClose={handleAddActionsClose}
            className="m-3"
          >
            <MenuItem
              className="mb-1 mt-3"
              onClick={() => onClickCancelar()}
              name="cancelarDfe"
              sx={{ height: 20, borderRadius: 5 }}
            >
              <ListItemIcon style={{ minWidth: 42 }}>
                <i className="ph-bold ph-x-circle" style={{ fontSize: 16 }}></i>
              </ListItemIcon>
              <span style={{ fontSize: 12 }}>Cancelar NFS-e</span>
            </MenuItem>
            <MenuItem
              className="mb-1 mt-3"
              onClick={onClickBaixarXml}
              name="baixarXml"
              sx={{ height: 20, borderRadius: 5 }}
            >
              <ListItemIcon style={{ minWidth: 42 }}>
                <i
                  className="ph-bold ph-file-arrow-down"
                  style={{ fontSize: 16 }}
                ></i>
              </ListItemIcon>
              <span style={{ fontSize: 12 }}>Baixar XML</span>
            </MenuItem>
          </Menu>
        </>
      );
    }
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{ mb: "0.5em" }}
    >
      {renderMainButtons()}
    </Grid>
  );
};

export default ButtonMenu;
